<template>
  <div class="SeePresentation">
    <!-- <iframe :src="ReportFileUrl"></iframe> -->
  </div>
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import pdf from "@/components/pdf";
Vue.use(pdf);
export default {
  data() {
    return {
      pdfUrl: ""
    };
  },
  created() {
    this.pdfUrl = this.$route.query.pdfUrl;
    this.$loading("加载报告");
    this.$showPDF(this.pdfUrl);
  },
  /**
   * 该组件卸载时，移除scrollToTop事件
   */ destroyed() {
    document.querySelector("#container").style.display = "none";
  }
};
</script>
<style lang="less" scoped>
.SeePresentation {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>


